import React from "react";
import { AgeValidationResult } from "../../hooks/useAgeValidation";
import { Alert, Box, Chip } from "@mui/material";

interface AgeValidationAlertProps {
  validationResult: AgeValidationResult;
  categoryName?: string;
}

export const AgeValidationAlert: React.FC<AgeValidationAlertProps> = ({
  validationResult,
  categoryName,
}) => {
  const { isValid, maxAllowedParticipants, exceededParticipants } = validationResult;

  if (isValid) {
    return null;
  }

  return (
    <Alert
      severity="error"
      sx={{
        mb: 3,
        border: "1px solid",
        borderColor: "error.main",
        borderRadius: 2,
      }}
    >
      <Box>
        Przekroczono limit starszych zawodników
        {categoryName && ` w kategorii "${categoryName}"`} <br />
        Dopuszczalny limit starszych zawodników to <strong>{maxAllowedParticipants}</strong>, mamy{" "}
        <strong>{exceededParticipants.length}</strong>:
        {exceededParticipants.length > 0 && (
          <Box sx={{ mt: 1 }}>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
              {exceededParticipants.map((participant, index) => (
                <Chip
                  key={participant.id || index}
                  label={`${participant.firstName} ${participant.lastName}`}
                  color="default"
                  size="small"
                  sx={{
                    backgroundColor: "error.main",
                    color: "error.contrastText",
                    "&:hover": {
                      backgroundColor: "error.dark",
                    },
                  }}
                />
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </Alert>
  );
};
